import { getNoaId, getOrganizationId } from "../../utils/session.utils";
import { setGamesErrors, setRafflesErrors } from "../../store/slices/errors";
import { setTotalRafflesPages } from "../../store/slices/paginationSlice";
import apiClient from "../../utils/api.client";
const serviceName = "game-service";

async function getAllRaffles(orgId, dispatch, page, perPage, sort) {
  try {
    const { criteria, field } = sort;
    const response = await apiClient.get(
      `/game-service/organizations/${orgId}/raffles?pageNumber=${page || 1}&pageSize=${perPage || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "createDate"}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllRaffles EP: ", error);
    dispatch(
      setRafflesErrors({ error: true, code: error.status || error.message }),
    );
    throw error;
  }
}

const getGameRaffles = async (gameId, dispatch) => {
  /* try {
    const response = await fetch(`${getServiceUrl()}/games/${gameId}/raffles?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=raffleDate`, {
      method: "GET",
      headers: { "Content-Type": "application/json", "accept": "application/json" }
    });
    if (response.status === 200) {
      dispatch(setRafflesErrors({ error: false }))
      return await response.json();
    } else {
      throw new Error(response.status)
    }
  } catch (e) {
    console.log()
  } */
  const url = `/game-service/games/${gameId}/raffles?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=raffleDate`;
  try {
    const response = await apiClient.get(url);
    if (response.status === 200) {
      const data = response.data;
      dispatch(setRafflesErrors({ error: false }));
      return data;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    console.error("Error at getGameRaffles EP: ", error);
    throw error;
  }
};

const getRaffleGameOffers = async (organizationId, pageNumber, dispatch) => {
  /* try {
    const response = await fetch(`${getServiceUrl()}/organizations/${organizationId}/gameOffers?pageNumber=${pageNumber}&pageSize=20&orderCriteria=DESC&orderField=id`, {
      method: "GET",
      headers: { "Content-Type": "application/json", "accept": "application/json" }
    })
    if (response.status === 200) {
      dispatch(setGamesErrors({ error: false }))
      return response.json();
    } else {
      throw new Error(response.status)
    }
  } catch (e) {
    console.log(e)
    dispatch(setGamesErrors({ error: true, code: e.status || e.message }))
  } */
  try {
    const url = `/${serviceName}/organizations/${organizationId}/gameOffers?pageNumber=${pageNumber}&pageSize=20&orderCriteria=DESC&orderField=id`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getRaffleGameOffers EP: ", error);
    throw error;
  }
};

const queryBuilder = (baseUrl, querys) => {
  baseUrl += querys["fromCloseDate"]
    ? `&fromCloseDate=${querys["fromCloseDate"]}`
    : "";
  baseUrl += querys["toCloseDate"]
    ? `&toCloseDate=${querys["toCloseDate"]}`
    : "";
  baseUrl += querys["fromRaffleDate"]
    ? `&fromRaffleDate=${querys["fromRaffleDate"]}`
    : "";
  baseUrl += querys["toRaffleDate"]
    ? `&toRaffleDate=${querys["toRaffleDate"]}`
    : "";
  return baseUrl;
};

const getAllRafflesFiltered = async (
  page,
  pageSize,
  gameId,
  modeId,
  querys,
  dispatch,
  sort,
) => {
  /* try {
    const { criteria, field } = sort;
    let url = `${getServiceUrl()}/games/${gameId}/modes/${modeId}/raffles?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'raffleDate'}`
    let url2 = null
    if (querys['query']) {
      url += `&query=${querys['query']}`
    } else if (querys['fromCloseDate'] || querys['toCloseDate'] || querys['fromRaffleDate'] || querys['toRaffleDate']) {
      if (gameId) {
        url = queryBuilder(url, querys)
      }
      else {
        url2 = `${getServiceUrl()}/organizations/${orgId}/raffles?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'raffleDate'}`
        url2 = queryBuilder(url2, querys)
      }
    }
    console.log("url 1 :", url, " url2: ", url2)
    const response = await fetch(url2 ? url2 : url)
    if (response.status === 200) {
      dispatch(setRafflesErrors({ error: false }))
      const json = await response.json();
      dispatch(setTotalRafflesPages(json?.content?.length !== 0 ? json.totalPages : 0))
      console.log("respuesta del back: ", json?.content)
      return json
    } else {
      throw new Error(response.status)
    }
  } catch (e) {
    dispatch(setRafflesErrors({ error: true, code: e.status || e.message }))
    console.log(e)
  } */
  const noaId = getNoaId();
  const { criteria, field } = sort;
  let url = `/game-service/games/${gameId}/modes/${modeId}/raffles?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "raffleDate"}`;
  let url2 = null;
  if (querys["query"]) {
    url += `&query=${querys["query"]}`;
  } else if (
    querys["fromCloseDate"] ||
    querys["toCloseDate"] ||
    querys["fromRaffleDate"] ||
    querys["toRaffleDate"]
  ) {
    if (gameId) {
      url = queryBuilder(url, querys);
    } else {
      url2 = `/game-service/organizations/${noaId}/raffles?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "raffleDate"}`;
      url2 = queryBuilder(url2, querys);
    }
  }

  console.log("url 1 :", url, " url2: ", url2);

  try {
    const response = await apiClient.get(url2 ? url2 : url);
    if (response.status === 200) {
      dispatch(setRafflesErrors({ error: false }));
      const data = await response.data;
      dispatch(
        setTotalRafflesPages(data?.content?.length !== 0 ? data.totalPages : 0),
      );
      console.log("respuesta del back: ", data?.content);
      return data;
    } else {
      throw new Error(response.status);
    }
  } catch (e) {
    dispatch(setRafflesErrors({ error: true, code: e.status || e.message }));
    console.error(e);
  }
};

const getRaffleLoteries = async (organizationId = getOrganizationId()) => {
  // try {
  //   const response = await fetch(`${getServiceUrl()}/lotteries?pageNumber=1&pageSize=200&orderCriteria=DESC&orderField=id`, {
  //     method: "GET",
  //     headers: { "Content-Type": "application/json", "accept": "application/json" }
  //   });
  //   if (response.status === 200) {
  //     return await response.json();
  //   } else {
  //     throw new Error(response.status)
  //   }
  // } catch (e) {
  //   console.log(e)
  // }

  try {
    const response = await apiClient.get(
      `/game-service/lotteries?pageNumber=1&pageSize=200&orderCriteria=DESC&orderField=id&organizationId=${organizationId}`,
    );
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    console.error("Error at getRaffleLoteries EP: ", error);
    throw error;
  }
};

const createRaffle = async (gameId, modeId, payload) => {
  const url = `/game-service/games/${gameId}/modes/${modeId}/raffles`;
  try {
    const response = await apiClient.post(url, payload);
    if (response.status === 200) {
      const data = response.data;
      return data;
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    console.error("Error at createRaffle EP", error);
    throw error;
  }
};

const editRaffle = async (gameId, modeId, payload) => {
  let url = `/game-service/games/${gameId}/modes/${modeId}/raffles`;
  try {
    const response = await apiClient.put(url, payload);
    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error at editRaffle EP: ", error);
    throw error;
  }
};

const getFilteredRaffles = async (
  gameId,
  modeId,
  page,
  raffleDate,
  dispatch,
) => {
  let url = `/game-service/games/${gameId}/modes/${modeId}/raffles?pageNumber=${page || 1}&pageSize=10&orderCriteria=DESC&orderField=raffleDate${raffleDate ? `&fromRaffleDate=${raffleDate}` : ""}`;
  try {
    const response = await apiClient.get(url);
    const data = await response.data;
    dispatch(setRafflesErrors({ error: false }));

    return data;
  } catch (error) {
    console.error("Error at getFilteredRaffles EP: ", error);
    throw error;
  }
};

const raffleService = {
  getAllRaffles,
  getGameRaffles,
  getRaffleGameOffers,
  getAllRafflesFiltered,
  getRaffleLoteries,
  createRaffle,
  editRaffle,
  getFilteredRaffles,
};

export default raffleService;
